export const backgroundImages = {
  desktop_bg: require("@/assets/desktop/desktop_bg.png"),

  healthWxIndex1: require("@/assets/health/wx/1.jpg"),
  healthWxIndex2: require("@/assets/health/wx/2.jpg"),
  healthWxIndex3: require("@/assets/health/wx/3.jpg"),
  healthWxIndex4: require("@/assets/health/wx/4.jpg"),

  healthZfbIndex1: require("@/assets/health/zfb/1.jpg"),
  healthZfbIndex2: require("@/assets/health/zfb/2.jpg"),
  healthZfbIndex3: require("@/assets/health/zfb/3.jpg"),

  // 预约挂号，微信，主流程图片
  registerWxIndex5: require("@/assets/health/register/wx/5.jpg"),
  registerWxIndex6: require("@/assets/health/register/wx/6.jpg"),
  registerWxIndex7: require("@/assets/health/register/wx/7.jpg"),
  registerWxIndex8: require("@/assets/health/register/wx/8.jpg"),
  registerWxIndex9: require("@/assets/health/register/wx/9.jpg"),
  registerWxIndex10: require("@/assets/health/register/wx/10.jpg"),
  registerWxIndex11: require("@/assets/health/register/wx/11.jpg"),
  registerWxIndex12: require("@/assets/health/register/wx/12.jpg"),
  registerWxIndex13: require("@/assets/health/register/wx/13.jpg"),
  registerWxIndex14: require("@/assets/health/register/wx/14.jpg"),
  registerWxIndex15: require("@/assets/health/register/wx/15.jpg"),
  registerWxIndex16: require("@/assets/health/register/wx/16.jpg"),
  // 预约挂号，微信，分支1图片
  registerWxBranch1Index1: require("@/assets/health/register/wx/branch1/1.jpg"),
  registerWxBranch1Index2: require("@/assets/health/register/wx/branch1/2.jpg"),
  registerWxBranch1Index3: require("@/assets/health/register/wx/branch1/3.jpg"),
  registerWxBranch1Index41: require("@/assets/health/register/wx/branch1/4-1.jpg"),
  registerWxBranch1Index42: require("@/assets/health/register/wx/branch1/4-2.jpg"),
  registerWxBranch1Index5: require("@/assets/health/register/wx/branch1/5.jpg"),
  registerWxBranch1Index6: require("@/assets/health/register/wx/branch1/6.jpg"),
  registerWxBranch1Index7: require("@/assets/health/register/wx/branch1/7.jpg"),
  // 预约挂号，微信，分支2图片
  registerWxBranch2Index1: require("@/assets/health/register/wx/branch2/1.jpg"),
  registerWxBranch2Index2: require("@/assets/health/register/wx/branch2/2.jpg"),
  registerWxBranch2Index3: require("@/assets/health/register/wx/branch2/3.jpg"),
  registerWxBranch2Index4: require("@/assets/health/register/wx/branch2/4.jpg"),
  registerWxBranch2Index5: require("@/assets/health/register/wx/branch2/5.jpg"),
  // 预约挂号，支付宝，主流程图片
  registerZfbIndex4: require("@/assets/health/register/zfb/4.jpg"),
  registerZfbIndex5: require("@/assets/health/register/zfb/5.jpg"),
  registerZfbIndex6: require("@/assets/health/register/zfb/6.jpg"),
  registerZfbIndex7: require("@/assets/health/register/zfb/7.jpg"),
  registerZfbIndex8: require("@/assets/health/register/zfb/8.jpg"),
  registerZfbIndex9: require("@/assets/health/register/zfb/9.jpg"),
  registerZfbIndex10: require("@/assets/health/register/zfb/10.jpg"),
  registerZfbIndex11: require("@/assets/health/register/zfb/11.jpg"),
  registerZfbIndex12: require("@/assets/health/register/zfb/12.jpg"),
  registerZfbIndex13: require("@/assets/health/register/zfb/13.jpg"),
  registerZfbIndex14: require("@/assets/health/register/zfb/14.jpg"),
  registerZfbIndex15: require("@/assets/health/register/zfb/15.jpg"),
  // 预约挂号，支付宝，分支1图片
  registerZfbBranch1Index1: require("@/assets/health/register/zfb/branch1/1.jpg"),
  registerZfbBranch1Index2: require("@/assets/health/register/zfb/branch1/2.jpg"),
  registerZfbBranch1Index3: require("@/assets/health/register/zfb/branch1/3.jpg"),
  registerZfbBranch1Index4: require("@/assets/health/register/zfb/branch1/4.jpg"),
  registerZfbBranch1Index5: require("@/assets/health/register/zfb/branch1/5.jpg"),
  registerZfbBranch1Index6: require("@/assets/health/register/zfb/branch1/6.jpg"),
  // 预约挂号，支付宝，分支2图片
  registerZfbBranch2Index1: require("@/assets/health/register/zfb/branch2/1.jpg"),
  registerZfbBranch2Index2: require("@/assets/health/register/zfb/branch2/2.jpg"),
  registerZfbBranch2Index3: require("@/assets/health/register/zfb/branch2/3.jpg"),
  registerZfbBranch2Index4: require("@/assets/health/register/zfb/branch2/4.jpg"),
  registerZfbBranch2Index5: require("@/assets/health/register/zfb/branch2/5.jpg"),

  // 医保电子凭证激活，微信，主流程图片
  activationWxIndex5: require("@/assets/health/activation/wx/5.jpg"),
  activationWxIndex6: require("@/assets/health/activation/wx/6.jpg"),
  activationWxIndex7: require("@/assets/health/activation/wx/7.jpg"),
  activationWxIndex8: require("@/assets/health/activation/wx/8.jpg"),
  activationWxIndex9: require("@/assets/health/activation/wx/9.jpg"),
  // 医保电子凭证激活，支付宝，主流程图片
  activationZfbIndex4: require("@/assets/health/activation/zfb/3.jpg"),
  activationZfbIndex5: require("@/assets/health/activation/zfb/4.jpg"),

  // 医保支付，微信，主流程图片
  payWxIndex4: require("@/assets/health/pay/wx/4.jpg"),
  payWxIndex5: require("@/assets/health/pay/wx/5.jpg"),
  payWxIndex6: require("@/assets/health/pay/wx/6.jpg"),
  // 医保支付，支付宝，主流程图片
  payZfbIndex3: require("@/assets/health/pay/zfb/3.jpg"),
  payZfbIndex4: require("@/assets/health/pay/zfb/4.jpg"),

  // 医保账户查询，微信，主流程图片
  queryWxIndex5: require("@/assets/health/query/wx/5.jpg"),
  queryWxIndex6: require("@/assets/health/query/wx/6.jpg"),
  queryWxIndex7: require("@/assets/health/query/wx/7.jpg"),
  queryWxIndex8: require("@/assets/health/query/wx/8.jpg"),
  // 医保账户查询，支付宝，主流程图片
  queryZfbIndex4: require("@/assets/health/query/zfb/4.jpg"),
  queryZfbIndex5: require("@/assets/health/query/zfb/5.jpg"),
  queryZfbIndex6: require("@/assets/health/query/zfb/6.jpg"),
  queryZfbIndex7: require("@/assets/health/query/zfb/7.jpg"),

  // 城乡居民医疗保险缴费，微信，主流程图片
  insuranceWxIndex3: require("@/assets/health/insurance/wx/3.jpg"),
  insuranceWxIndex4: require("@/assets/health/insurance/wx/4.jpg"),
  insuranceWxIndex5: require("@/assets/health/insurance/wx/5.jpg"),
  insuranceWxIndex6: require("@/assets/health/insurance/wx/6.jpg"),
  insuranceWxIndex7: require("@/assets/health/insurance/wx/7.jpg"),
  insuranceWxIndex8: require("@/assets/health/insurance/wx/8.jpg"),
  insuranceWxIndex9: require("@/assets/health/insurance/wx/9.jpg"),
  insuranceWxIndex10: require("@/assets/health/insurance/wx/10.jpg"),
  insuranceWxIndex11: require("@/assets/health/insurance/wx/11.jpg"),
  // 城乡居民医疗保险缴费，支付宝，主流程图片
  insuranceZfbIndex3: require("@/assets/health/insurance/zfb/3.jpg"),
  insuranceZfbIndex4: require("@/assets/health/insurance/zfb/4.jpg"),
  insuranceZfbIndex5: require("@/assets/health/insurance/zfb/5.jpg"),
  insuranceZfbIndex6: require("@/assets/health/insurance/zfb/6.jpg"),
  insuranceZfbIndex7: require("@/assets/health/insurance/zfb/7.jpg"),
  insuranceZfbIndex8: require("@/assets/health/insurance/zfb/8.jpg"),
  insuranceZfbIndex9: require("@/assets/health/insurance/zfb/9.jpg"),
  insuranceZfbIndex10: require("@/assets/health/insurance/zfb/10.jpg"),

  // 门诊慢特病病种申请，微信，主流程图片
  applyWxIndex2: require("@/assets/health/apply/wx/2.jpg"),
  applyWxIndex3: require("@/assets/health/apply/wx/3.jpg"),
  applyWxIndex4: require("@/assets/health/apply/wx/4.jpg"),
  applyWxIndex5: require("@/assets/health/apply/wx/5.jpg"),
  applyWxIndex6: require("@/assets/health/apply/wx/6.jpg"),
  applyWxIndex7: require("@/assets/health/apply/wx/7.jpg"),
  applyWxIndex8: require("@/assets/health/apply/wx/8.jpg"),
  applyWxIndex9: require("@/assets/health/apply/wx/9.jpg"),
  applyWxIndex10: require("@/assets/health/apply/wx/10.jpg"),
  applyWxIndex11: require("@/assets/health/apply/wx/11.jpg"),
  applyWxIndex12: require("@/assets/health/apply/wx/12.jpg"),
  // 门诊慢特病病种申请，支付宝，主流程图片
  applyZfbIndex3: require("@/assets/health/apply/zfb/3.jpg"),
  applyZfbIndex4: require("@/assets/health/apply/zfb/4.jpg"),

  // 在线问诊，支付宝，主流程图片
  consultationZfbIndex4: require("@/assets/health/consultation/zfb/4.jpg"),
  consultationZfbIndex5: require("@/assets/health/consultation/zfb/5.jpg"),
  consultationZfbIndex6: require("@/assets/health/consultation/zfb/6.jpg"),
  consultationZfbIndex7: require("@/assets/health/consultation/zfb/7.jpg"),
  consultationZfbIndex8: require("@/assets/health/consultation/zfb/8.jpg"),
  consultationZfbIndex9: require("@/assets/health/consultation/zfb/9.jpg"),
  consultationZfbIndex10: require("@/assets/health/consultation/zfb/10.jpg"),
  consultationZfbIndex11: require("@/assets/health/consultation/zfb/11.jpg"),

  // 手机买药，支付宝，主流程图片
  medicineZfbIndex4: require("@/assets/health/medicine/zfb/4.jpg"),
  medicineZfbIndex5: require("@/assets/health/medicine/zfb/5.jpg"),
  medicineZfbIndex6: require("@/assets/health/medicine/zfb/6.jpg"),
  medicineZfbIndex7: require("@/assets/health/medicine/zfb/7.jpg"),
  medicineZfbIndex8: require("@/assets/health/medicine/zfb/8.jpg"),
  medicineZfbIndex9: require("@/assets/health/medicine/zfb/9.jpg"),
  medicineZfbIndex10: require("@/assets/health/medicine/zfb/10.jpg"),
  medicineZfbIndex11: require("@/assets/health/medicine/zfb/11.jpg"),
  medicineZfbIndex12: require("@/assets/health/medicine/zfb/12.jpg"),
  medicineZfbIndex13: require("@/assets/health/medicine/zfb/13.jpg"),
  medicineZfbIndex14: require("@/assets/health/medicine/zfb/14.jpg"),
  medicineZfbIndex15: require("@/assets/health/medicine/zfb/15.jpg"),
  // 手机买药，支付宝，分支1图片
  medicineZfbBranch1Index1: require("@/assets/health/medicine/zfb/branch1/1.jpg"),
  medicineZfbBranch1Index2: require("@/assets/health/medicine/zfb/branch1/2.jpg"),
  // 手机买药，支付宝，分支2图片
  medicineZfbBranch2Index1: require("@/assets/health/medicine/zfb/branch2/1.jpg"),
  medicineZfbBranch2Index2: require("@/assets/health/medicine/zfb/branch2/2.jpg"),
  medicineZfbBranch2Index3: require("@/assets/health/medicine/zfb/branch2/3.jpg"),

  // 乘车码调用，微信，主流程图片
  codeWxIndex2: require("@/assets/traffic/code/wx/2.jpg"),
  codeWxIndex3: require("@/assets/traffic/code/wx/3.jpg"),
  codeWxIndex4: require("@/assets/traffic/code/wx/4.jpg"),
  codeWxIndex5: require("@/assets/traffic/code/wx/5.jpg"),
  codeWxIndex6: require("@/assets/traffic/code/wx/6.jpg"),
  codeWxIndex7: require("@/assets/traffic/code/wx/7.jpg"),
  codeWxIndex8: require("@/assets/traffic/code/wx/8.jpg"),
  codeWxIndex9: require("@/assets/traffic/code/wx/9.jpg"),
  codeWxIndex10: require("@/assets/traffic/code/wx/10.jpg"),
  codeWxIndex11: require("@/assets/traffic/code/wx/11.jpg"),
  codeWxIndex12: require("@/assets/traffic/code/wx/12.jpg"),
  // 乘车码调用，支付宝，主流程图片
  codeZfbIndex2: require("@/assets/traffic/code/zfb/2.jpg"),
  codeZfbIndex3: require("@/assets/traffic/code/zfb/3.jpg"),
  codeZfbIndex4: require("@/assets/traffic/code/zfb/4.jpg"),
  codeZfbIndex5: require("@/assets/traffic/code/zfb/5.jpg"),
  codeZfbIndex6: require("@/assets/traffic/code/zfb/6.jpg"),

  // 养老待遇资格认证，微信，主流程图片
  authenticationWxIndex2: require("@/assets/society/authentication/wx/2.jpg"),
  authenticationWxIndex3: require("@/assets/society/authentication/wx/3.jpg"),
  authenticationWxIndex4: require("@/assets/society/authentication/wx/4.jpg"),
  authenticationWxIndex5: require("@/assets/society/authentication/wx/5.jpg"),
  authenticationWxIndex6: require("@/assets/society/authentication/wx/6.jpg"),
  authenticationWxIndex7: require("@/assets/society/authentication/wx/7.jpg"),
  authenticationWxIndex8: require("@/assets/society/authentication/wx/8.jpg"),
  authenticationWxIndex9: require("@/assets/society/authentication/wx/9.jpg"),
  // 养老待遇资格认证，支付宝，主流程图片
  authenticationZfbIndex2: require("@/assets/society/authentication/zfb/2.jpg"),
  authenticationZfbIndex3: require("@/assets/society/authentication/zfb/3.jpg"),
  authenticationZfbIndex5: require("@/assets/society/authentication/zfb/5.jpg"),
  authenticationZfbIndex6: require("@/assets/society/authentication/zfb/6.jpg"),
  // 养老待遇资格认证，皖事通，主流程图片
  authenticationWstIndex2: require("@/assets/society/authentication/wst/2.jpg"),
  authenticationWstIndex3: require("@/assets/society/authentication/wst/3.jpg"),
  authenticationWstIndex4: require("@/assets/society/authentication/wst/4.jpg"),
  authenticationWstIndex5: require("@/assets/society/authentication/wst/5.jpg"),
  authenticationWstIndex6: require("@/assets/society/authentication/wst/6.jpg"),
  authenticationWstIndex7: require("@/assets/society/authentication/wst/7.jpg"),
  authenticationWstIndex8: require("@/assets/society/authentication/wst/8.jpg"),
  authenticationWstIndex9: require("@/assets/society/authentication/wst/9.jpg"),
  authenticationWstIndex10: require("@/assets/society/authentication/wst/10.jpg"),

  // 城乡居民养老保险缴费，微信，主流程图片
  residentWxIndex2: require("@/assets/society/resident/wx/2.jpg"),
  residentWxIndex3: require("@/assets/society/resident/wx/3.jpg"),
  residentWxIndex4: require("@/assets/society/resident/wx/4.jpg"),
  residentWxIndex5: require("@/assets/society/resident/wx/5.jpg"),
  residentWxIndex6: require("@/assets/society/resident/wx/6.jpg"),
  residentWxIndex7: require("@/assets/society/resident/wx/7.jpg"),
  residentWxIndex8: require("@/assets/society/resident/wx/8.jpg"),
  residentWxIndex9: require("@/assets/society/resident/wx/9.jpg"),
  residentWxIndex10: require("@/assets/society/resident/wx/10.jpg"),

  // 城乡居民养老保险缴费，支付宝，主流程图片
  residentZfbIndex3: require("@/assets/society/resident/zfb/3.jpg"),
  residentZfbIndex4: require("@/assets/society/resident/zfb/4.jpg"),
  residentZfbIndex5: require("@/assets/society/resident/zfb/5.jpg"),
  residentZfbIndex6: require("@/assets/society/resident/zfb/6.jpg"),
  residentZfbIndex7: require("@/assets/society/resident/zfb/7.jpg"),
  residentZfbIndex8: require("@/assets/society/resident/zfb/8.jpg"),
  residentZfbIndex9: require("@/assets/society/resident/zfb/9.jpg"),
  // 城乡居民养老保险缴费，皖事通，主流程图片
  residentWstIndex2: require("@/assets/society/resident/wst/2.jpg"),
  residentWstIndex3: require("@/assets/society/resident/wst/3.jpg"),
  residentWstIndex4: require("@/assets/society/resident/wst/4.jpg"),
  residentWstIndex5: require("@/assets/society/resident/wst/5.jpg"),
  residentWstIndex6: require("@/assets/society/resident/wst/6.jpg"),
  residentWstIndex7: require("@/assets/society/resident/wst/7.jpg"),
  residentWstIndex8: require("@/assets/society/resident/wst/8.jpg"),
  residentWstIndex9: require("@/assets/society/resident/wst/9.jpg"),
  residentWstIndex10: require("@/assets/society/resident/wst/10.jpg"),
  residentWstIndex11: require("@/assets/society/resident/wst/11.jpg"),

  // 城乡居民养老保险待遇申请，主流程图片
  retirementZfbIndex10: require("@/assets/society/retirement/zfb/10.jpg"),
  retirementZfbIndex11: require("@/assets/society/retirement/zfb/11.jpg"),
  retirementZfbIndex12: require("@/assets/society/retirement/zfb/12.jpg"),
  retirementZfbIndex13: require("@/assets/society/retirement/zfb/13.jpg"),
  retirementZfbIndex14: require("@/assets/society/retirement/zfb/14.jpg"),
  retirementZfbIndex15: require("@/assets/society/retirement/zfb/15.jpg"),
  retirementZfbIndex16: require("@/assets/society/retirement/zfb/16.jpg"),

  // 手机点餐，美团，主流程图片
  eatMtIndex2: require("@/assets/shopping/eat/mt/2.jpg"),
  eatMtIndex3: require("@/assets/shopping/eat/mt/3.jpg"),
  eatMtIndex4: require("@/assets/shopping/eat/mt/4.jpg"),
  eatMtIndex5: require("@/assets/shopping/eat/mt/5.jpg"),
  eatMtIndex6: require("@/assets/shopping/eat/mt/6.jpg"),
  eatMtIndex7: require("@/assets/shopping/eat/mt/7.jpg"),
  eatMtIndex8: require("@/assets/shopping/eat/mt/8.jpg"),
  eatMtIndex9: require("@/assets/shopping/eat/mt/9.jpg"),
  eatMtIndex10: require("@/assets/shopping/eat/mt/10.jpg"),
  eatMtIndex11: require("@/assets/shopping/eat/mt/11.jpg"),
  eatMtIndex12: require("@/assets/shopping/eat/mt/12.jpg"),
  eatMtIndex13: require("@/assets/shopping/eat/mt/13.jpg"),
  eatMtIndex14: require("@/assets/shopping/eat/mt/14.jpg"),
  eatMtIndex15: require("@/assets/shopping/eat/mt/15.jpg"),
  eatMtIndex16: require("@/assets/shopping/eat/mt/16.jpg"),
  eatMtIndex17: require("@/assets/shopping/eat/mt/17.jpg"),
  eatMtIndex18: require("@/assets/shopping/eat/mt/18.jpg"),
  eatMtIndex19: require("@/assets/shopping/eat/mt/19.jpg"),
  // 手机点餐，饿了么，主流程图片
  eatElmIndex2: require("@/assets/shopping/eat/elm/2.jpg"),
  eatElmIndex3: require("@/assets/shopping/eat/elm/3.jpg"),
  eatElmIndex4: require("@/assets/shopping/eat/elm/4.jpg"),
  eatElmIndex5: require("@/assets/shopping/eat/elm/5.jpg"),
  eatElmIndex6: require("@/assets/shopping/eat/elm/6.jpg"),
  eatElmIndex7: require("@/assets/shopping/eat/elm/7.jpg"),
  eatElmIndex8: require("@/assets/shopping/eat/elm/8.jpg"),
  eatElmIndex9: require("@/assets/shopping/eat/elm/9.jpg"),
  eatElmIndex10: require("@/assets/shopping/eat/elm/10.jpg"),
  eatElmIndex11: require("@/assets/shopping/eat/elm/11.jpg"),
  eatElmIndex12: require("@/assets/shopping/eat/elm/12.jpg"),
  eatElmIndex13: require("@/assets/shopping/eat/elm/13.jpg"),
  eatElmIndex14: require("@/assets/shopping/eat/elm/14.jpg"),
  eatElmIndex15: require("@/assets/shopping/eat/elm/15.jpg"),
  eatElmIndex16: require("@/assets/shopping/eat/elm/16.jpg"),
  eatElmIndex17: require("@/assets/shopping/eat/elm/17.jpg"),
  eatElmIndex18: require("@/assets/shopping/eat/elm/18.jpg"),
  // 手机点餐，京东，主流程图片
  eatJdIndex2: require("@/assets/shopping/eat/jd/1-2.jpg"),
  eatJdIndex3: require("@/assets/shopping/eat/jd/1-3.jpg"),
  eatJdIndex4: require("@/assets/shopping/eat/jd/1-4.jpg"),
  eatJdIndex5: require("@/assets/shopping/eat/jd/1-5.jpg"),
  eatJdIndex6: require("@/assets/shopping/eat/jd/1-6.jpg"),
  eatJdIndex7: require("@/assets/shopping/eat/jd/1-7.jpg"),
  eatJdIndex8: require("@/assets/shopping/eat/jd/1-8.jpg"),
  eatJdIndex9: require("@/assets/shopping/eat/jd/1-9.jpg"),
  eatJdIndex10: require("@/assets/shopping/eat/jd/1-10.jpg"),
  eatJdIndex11: require("@/assets/shopping/eat/jd/1-11.jpg"),

  // 水费缴费，微信，主流程图片
  waterWxIndex3: require("@/assets/life/water/wx/3.jpg"),
  waterWxIndex4: require("@/assets/life/water/wx/4.jpg"),
  waterWxIndex5: require("@/assets/life/water/wx/5.jpg"),
  waterWxIndex6: require("@/assets/life/water/wx/6.jpg"),
  waterWxIndex7: require("@/assets/life/water/wx/7.jpg"),
  waterWxIndex8: require("@/assets/life/water/wx/8.jpg"),
  waterWxIndex9: require("@/assets/life/water/wx/9.jpg"),
  waterWxIndex10: require("@/assets/life/water/wx/10.jpg"),
  waterWxIndex12: require("@/assets/life/water/wx/12.jpg"),
  waterWxIndex13: require("@/assets/life/water/wx/13.jpg"),
  waterWxIndex14: require("@/assets/life/water/wx/14.jpg"),
  // 水费缴费，支付宝，主流程图片
  waterZfbIndex3: require("@/assets/life/water/zfb/3.jpg"),
  waterZfbIndex4: require("@/assets/life/water/zfb/4.jpg"),
  waterZfbIndex5: require("@/assets/life/water/zfb/5.jpg"),
  waterZfbIndex6: require("@/assets/life/water/zfb/6.jpg"),
  waterZfbIndex7: require("@/assets/life/water/zfb/7.jpg"),
  waterZfbIndex8: require("@/assets/life/water/zfb/8.jpg"),
  waterZfbIndex9: require("@/assets/life/water/zfb/9.jpg"),
  waterZfbIndex10: require("@/assets/life/water/zfb/10.jpg"),
  waterZfbIndex12: require("@/assets/life/water/zfb/12.jpg"),
  waterZfbIndex13: require("@/assets/life/water/zfb/13.jpg"),
  // 水费缴费，支付宝，分支1图片
  waterZfbBranch1Index1: require("@/assets/life/water/zfb/branch1/1.jpg"),
  waterZfbBranch1Index2: require("@/assets/life/water/zfb/branch1/2.jpg"),
  waterZfbBranch1Index3: require("@/assets/life/water/zfb/branch1/3.jpg"),
  waterZfbBranch1Index4: require("@/assets/life/water/zfb/branch1/4.jpg"),
  waterZfbBranch1Index5: require("@/assets/life/water/zfb/branch1/5.jpg"),
  waterZfbBranch1Index6: require("@/assets/life/water/zfb/branch1/6.jpg"),

  // 燃气费缴费，微信，主流程图片
  gasWxIndex4: require("@/assets/life/gas/wx/4.jpg"),
  gasWxIndex5: require("@/assets/life/gas/wx/5.jpg"),
  gasWxIndex6: require("@/assets/life/gas/wx/6.jpg"),
  gasWxIndex7: require("@/assets/life/gas/wx/7.jpg"),
  gasWxIndex8: require("@/assets/life/gas/wx/8.jpg"),
  gasWxIndex9: require("@/assets/life/gas/wx/9.jpg"),
  gasWxIndex10: require("@/assets/life/gas/wx/10.jpg"),
  gasWxIndex12: require("@/assets/life/gas/wx/12.jpg"),
  gasWxIndex13: require("@/assets/life/gas/wx/13.jpg"),
  gasWxIndex14: require("@/assets/life/gas/wx/14.jpg"),
  // 燃气费缴费，支付宝，主流程图片
  gasZfbIndex4: require("@/assets/life/gas/zfb/4.jpg"),
  gasZfbIndex5: require("@/assets/life/gas/zfb/5.jpg"),
  gasZfbIndex6: require("@/assets/life/gas/zfb/6.jpg"),
  gasZfbIndex7: require("@/assets/life/gas/zfb/7.jpg"),
  gasZfbIndex8: require("@/assets/life/gas/zfb/8.jpg"),
  gasZfbIndex9: require("@/assets/life/gas/zfb/9.jpg"),
  gasZfbIndex10: require("@/assets/life/gas/zfb/10.jpg"),
  gasZfbIndex12: require("@/assets/life/gas/zfb/12.jpg"),
  gasZfbIndex13: require("@/assets/life/gas/zfb/13.jpg"),
  // 燃气费缴费，支付宝，分支1图片
  gasZfbBranch1Index3: require("@/assets/life/gas/zfb/branch1/3.jpg"),
  gasZfbBranch1Index5: require("@/assets/life/gas/zfb/branch1/5.jpg"),

  // 手机打车，百度地图，主流程图片
  carBdIndex1: require("@/assets/traffic/car/bd/1.jpg"),
  carBdIndex2: require("@/assets/traffic/car/bd/2.jpg"),
  carBdIndex3: require("@/assets/traffic/car/bd/3.jpg"),
  carBdIndex4: require("@/assets/traffic/car/bd/4.jpg"),
  carBdIndex5: require("@/assets/traffic/car/bd/5.jpg"),
  carBdIndex6: require("@/assets/traffic/car/bd/6.jpg"),
  carBdIndex7: require("@/assets/traffic/car/bd/7.jpg"),
  carBdIndex8: require("@/assets/traffic/car/bd/8.jpg"),
  // 手机打车，百度地图，分支1图片
  carBdBranch1Index2: require("@/assets/traffic/car/bd/branch1/2.jpg"),
  carBdBranch1Index3: require("@/assets/traffic/car/bd/branch1/3.jpg"),
  carBdBranch1Index4: require("@/assets/traffic/car/bd/branch1/4.jpg"),
  // 手机打车，百度地图，分支1图片
  carBdBranch2Index2: require("@/assets/traffic/car/bd/branch2/2.jpg"),
  carBdBranch2Index3: require("@/assets/traffic/car/bd/branch2/3.jpg"),
  carBdBranch2Index4: require("@/assets/traffic/car/bd/branch2/4.jpg"),
  carBdBranch2Index5: require("@/assets/traffic/car/bd/branch2/5.jpg"),
  // 手机打车，高德地图，主流程图片
  carGdIndex1: require("@/assets/traffic/car/gd/1.jpg"),
  carGdIndex2: require("@/assets/traffic/car/gd/2.jpg"),
  carGdIndex3: require("@/assets/traffic/car/gd/3.jpg"),
  carGdIndex4: require("@/assets/traffic/car/gd/4.jpg"),
  carGdIndex5: require("@/assets/traffic/car/gd/5.jpg"),
  carGdIndex6: require("@/assets/traffic/car/gd/6.jpg"),
  carGdIndex7: require("@/assets/traffic/car/gd/7.jpg"),
  // 手机打车，高德地图，分支1图片
  carGdBranch1Index1: require("@/assets/traffic/car/gd/branch1/1.jpg"),
  carGdBranch1Index2: require("@/assets/traffic/car/gd/branch1/2.jpg"),
  carGdBranch1Index3: require("@/assets/traffic/car/gd/branch1/3.jpg"),
  carGdBranch1Index4: require("@/assets/traffic/car/gd/branch1/4.jpg"),
  carGdBranch1Index5: require("@/assets/traffic/car/gd/branch1/5.jpg"),
  carGdBranch1Index6: require("@/assets/traffic/car/gd/branch1/6.jpg"),
  carGdBranch1Index7: require("@/assets/traffic/car/gd/branch1/7.jpg"),
  // 手机打车，高德地图，分支2图片
  carGdBranch2Index1: require("@/assets/traffic/car/gd/branch2/1.jpg"),
  carGdBranch2Index2: require("@/assets/traffic/car/gd/branch2/2.jpg"),
  carGdBranch2Index3: require("@/assets/traffic/car/gd/branch2/3.jpg"),
  carGdBranch2Index4: require("@/assets/traffic/car/gd/branch2/4.jpg"),
  carGdBranch2Index5: require("@/assets/traffic/car/gd/branch2/5.jpg"),
  // 手机打车，微信，主流程图片
  carWxIndex3: require("@/assets/traffic/car/wx/3.jpg"),
  carWxIndex4: require("@/assets/traffic/car/wx/4.jpg"),
  carWxIndex5: require("@/assets/traffic/car/wx/5.jpg"),
  carWxIndex6: require("@/assets/traffic/car/wx/6.jpg"),
  carWxIndex7: require("@/assets/traffic/car/wx/7.jpg"),
  carWxIndex8: require("@/assets/traffic/car/wx/8.jpg"),
  carWxIndex9: require("@/assets/traffic/car/wx/9.jpg"),
  // 手机打车，微信，分支1图片
  carWxBranch1Index1: require("@/assets/traffic/car/wx/branch1/1.jpg"),
  carWxBranch1Index2: require("@/assets/traffic/car/wx/branch1/2.jpg"),
  carWxBranch1Index3: require("@/assets/traffic/car/wx/branch1/3.jpg"),
  carWxBranch1Index4: require("@/assets/traffic/car/wx/branch1/4.jpg"),
  carWxBranch1Index5: require("@/assets/traffic/car/wx/branch1/5.jpg"),
  // 手机打车，微信，分支2图片
  carWxBranch2Index1: require("@/assets/traffic/car/wx/branch2/1.jpg"),
  carWxBranch2Index2: require("@/assets/traffic/car/wx/branch2/2.jpg"),
  carWxBranch2Index3: require("@/assets/traffic/car/wx/branch2/3.jpg"),
  carWxBranch2Index4: require("@/assets/traffic/car/wx/branch2/4.jpg"),
  carWxBranch2Index5: require("@/assets/traffic/car/wx/branch2/5.jpg"),
  carWxBranch2Index6: require("@/assets/traffic/car/wx/branch2/6.jpg"),
  carWxBranch2Index7: require("@/assets/traffic/car/wx/branch2/7.jpg"),
  // 手机打车，支付宝，主流程图片
  carZfbIndex2: require("@/assets/traffic/car/zfb/2.jpg"),
  carZfbIndex3: require("@/assets/traffic/car/zfb/3.jpg"),
  carZfbIndex4: require("@/assets/traffic/car/zfb/4.jpg"),
  carZfbIndex5: require("@/assets/traffic/car/zfb/5.jpg"),
  carZfbIndex6: require("@/assets/traffic/car/zfb/6.jpg"),
  carZfbIndex7: require("@/assets/traffic/car/zfb/7.jpg"),
  carZfbIndex8: require("@/assets/traffic/car/zfb/8.jpg"),
  // 手机打车，支付宝，分支1图片
  carZfbBranch1Index1: require("@/assets/traffic/car/zfb/branch1/1.jpg"),
  carZfbBranch1Index2: require("@/assets/traffic/car/zfb/branch1/2.jpg"),
  carZfbBranch1Index3: require("@/assets/traffic/car/zfb/branch1/3.jpg"),
  carZfbBranch1Index4: require("@/assets/traffic/car/zfb/branch1/4.jpg"),
  carZfbBranch1Index5: require("@/assets/traffic/car/zfb/branch1/5.jpg"),
  carZfbBranch1Index6: require("@/assets/traffic/car/zfb/branch1/6.jpg"),
  // 手机打车，支付宝，分支2图片
  carZfbBranch2Index1: require("@/assets/traffic/car/zfb/branch2/1.jpg"),
  carZfbBranch2Index2: require("@/assets/traffic/car/zfb/branch2/2.jpg"),
  carZfbBranch2Index3: require("@/assets/traffic/car/zfb/branch2/3.jpg"),
  carZfbBranch2Index4: require("@/assets/traffic/car/zfb/branch2/4.jpg"),
  carZfbBranch2Index5: require("@/assets/traffic/car/zfb/branch2/5.jpg"),

  // 买飞机票，微信，主流程图片
  aircraftWxIndex2: require("@/assets/traffic/aircraft/wx/1-2.jpg"),
  aircraftWxIndex3: require("@/assets/traffic/aircraft/wx/1-3.jpg"),
  aircraftWxIndex4: require("@/assets/traffic/aircraft/wx/1-4.jpg"),
  aircraftWxIndex5: require("@/assets/traffic/aircraft/wx/1-5.jpg"),
  aircraftWxIndex6: require("@/assets/traffic/aircraft/wx/1-6.jpg"),
  aircraftWxIndex7: require("@/assets/traffic/aircraft/wx/1-7.jpg"),
  aircraftWxIndex8: require("@/assets/traffic/aircraft/wx/1-8.jpg"),
  aircraftWxIndex9: require("@/assets/traffic/aircraft/wx/1-9.jpg"),
  aircraftWxIndex10: require("@/assets/traffic/aircraft/wx/1-10.jpg"),
  aircraftWxIndex11: require("@/assets/traffic/aircraft/wx/1-11.jpg"),
  aircraftWxIndex12: require("@/assets/traffic/aircraft/wx/1-12.jpg"),
  aircraftWxIndex13: require("@/assets/traffic/aircraft/wx/1-13.jpg"),
  aircraftWxIndex14: require("@/assets/traffic/aircraft/wx/1-14.jpg"),
  aircraftWxIndex15: require("@/assets/traffic/aircraft/wx/1-15.jpg"),
  aircraftWxIndex16: require("@/assets/traffic/aircraft/wx/1-16.jpg"),
  aircraftWxIndex17: require("@/assets/traffic/aircraft/wx/1-17.jpg"),
  aircraftWxIndex18: require("@/assets/traffic/aircraft/wx/1-18.jpg"),
  aircraftWxIndex19: require("@/assets/traffic/aircraft/wx/1-19.jpg"),
  aircraftWxIndex20: require("@/assets/traffic/aircraft/wx/1-20.jpg"),
  aircraftWxIndex21: require("@/assets/traffic/aircraft/wx/1-21.jpg"),
  aircraftWxIndex22: require("@/assets/traffic/aircraft/wx/1-22.jpg"),

  // 买飞机票，支付宝，主流程图片
  aircraftZfbIndex2: require("@/assets/traffic/aircraft/zfb/1-2.jpg"),
  aircraftZfbIndex3: require("@/assets/traffic/aircraft/zfb/1-3.jpg"),
  aircraftZfbIndex4: require("@/assets/traffic/aircraft/zfb/1-4.jpg"),
  aircraftZfbIndex5: require("@/assets/traffic/aircraft/zfb/1-5.jpg"),
  aircraftZfbIndex6: require("@/assets/traffic/aircraft/zfb/1-6.jpg"),
  aircraftZfbIndex7: require("@/assets/traffic/aircraft/zfb/1-7.jpg"),
  aircraftZfbIndex8: require("@/assets/traffic/aircraft/zfb/1-8.jpg"),
  aircraftZfbIndex9: require("@/assets/traffic/aircraft/zfb/1-9.jpg"),
  aircraftZfbIndex10: require("@/assets/traffic/aircraft/zfb/1-10.jpg"),
  aircraftZfbIndex11: require("@/assets/traffic/aircraft/zfb/1-11.jpg"),
  aircraftZfbIndex12: require("@/assets/traffic/aircraft/zfb/1-12.jpg"),
  aircraftZfbIndex13: require("@/assets/traffic/aircraft/zfb/1-13.jpg"),
  aircraftZfbIndex14: require("@/assets/traffic/aircraft/zfb/1-14.jpg"),
  aircraftZfbIndex15: require("@/assets/traffic/aircraft/zfb/1-15.jpg"),
  aircraftZfbIndex16: require("@/assets/traffic/aircraft/zfb/1-16.jpg"),
  aircraftZfbIndex17: require("@/assets/traffic/aircraft/zfb/1-17.jpg"),
  aircraftZfbIndex18: require("@/assets/traffic/aircraft/zfb/1-18.jpg"),
  aircraftZfbIndex19: require("@/assets/traffic/aircraft/zfb/1-19.jpg"),
  aircraftZfbIndex20: require("@/assets/traffic/aircraft/zfb/1-20.jpg"),

  // 买飞机票，铁路12306，主流程图片
  aircraftTlIndex2: require("@/assets/traffic/aircraft/tl/1-2.jpg"),
  aircraftTlIndex3: require("@/assets/traffic/aircraft/tl/1-3.jpg"),
  aircraftTlIndex4: require("@/assets/traffic/aircraft/tl/1-4.jpg"),
  aircraftTlIndex5: require("@/assets/traffic/aircraft/tl/1-5.jpg"),
  aircraftTlIndex6: require("@/assets/traffic/aircraft/tl/1-6.jpg"),
  aircraftTlIndex7: require("@/assets/traffic/aircraft/tl/1-7.jpg"),
  aircraftTlIndex8: require("@/assets/traffic/aircraft/tl/1-8.jpg"),
  aircraftTlIndex9: require("@/assets/traffic/aircraft/tl/1-9.jpg"),
  aircraftTlIndex10: require("@/assets/traffic/aircraft/tl/1-10.jpg"),
  aircraftTlIndex11: require("@/assets/traffic/aircraft/tl/1-11.jpg"),
  aircraftTlIndex12: require("@/assets/traffic/aircraft/tl/1-12.jpg"),
  aircraftTlIndex13: require("@/assets/traffic/aircraft/tl/1-13.jpg"),
  aircraftTlIndex14: require("@/assets/traffic/aircraft/tl/1-14.jpg"),
  aircraftTlIndex15: require("@/assets/traffic/aircraft/tl/1-15.jpg"),
  aircraftTlIndex16: require("@/assets/traffic/aircraft/tl/1-16.jpg"),
  aircraftTlIndex17: require("@/assets/traffic/aircraft/tl/1-17.jpg"),
  aircraftTlIndex18: require("@/assets/traffic/aircraft/tl/1-18.jpg"),
  aircraftTlIndex19: require("@/assets/traffic/aircraft/tl/1-19.jpg"),
  aircraftTlIndex20: require("@/assets/traffic/aircraft/tl/1-20.jpg"),

  // 买火车票，微信，主流程图片
  trainWxIndex2: require("@/assets/traffic/train/wx/1-2.jpg"),
  trainWxIndex3: require("@/assets/traffic/train/wx/1-3.jpg"),
  trainWxIndex4: require("@/assets/traffic/train/wx/1-4.jpg"),
  trainWxIndex5: require("@/assets/traffic/train/wx/1-5.jpg"),
  trainWxIndex6: require("@/assets/traffic/train/wx/1-6.jpg"),
  trainWxIndex7: require("@/assets/traffic/train/wx/1-7.jpg"),
  trainWxIndex8: require("@/assets/traffic/train/wx/1-8.jpg"),
  trainWxIndex9: require("@/assets/traffic/train/wx/1-9.jpg"),
  trainWxIndex10: require("@/assets/traffic/train/wx/1-10.jpg"),
  trainWxIndex11: require("@/assets/traffic/train/wx/1-11.jpg"),
  trainWxIndex12: require("@/assets/traffic/train/wx/1-12.jpg"),
  trainWxIndex13: require("@/assets/traffic/train/wx/1-13.jpg"),
  trainWxIndex14: require("@/assets/traffic/train/wx/1-14.jpg"),
  trainWxIndex15: require("@/assets/traffic/train/wx/1-15.jpg"),
  trainWxIndex16: require("@/assets/traffic/train/wx/1-16.jpg"),
  trainWxIndex17: require("@/assets/traffic/train/wx/1-17.jpg"),
  trainWxIndex18: require("@/assets/traffic/train/wx/1-18.jpg"),
  trainWxIndex19: require("@/assets/traffic/train/wx/1-19.jpg"),
  trainWxIndex20: require("@/assets/traffic/train/wx/1-20.jpg"),
  trainWxIndex21: require("@/assets/traffic/train/wx/1-21.jpg"),

  // 买火车票，支付宝，主流程图片
  trainZfbIndex2: require("@/assets/traffic/train/zfb/1-2.jpg"),
  trainZfbIndex3: require("@/assets/traffic/train/zfb/1-3.jpg"),
  trainZfbIndex4: require("@/assets/traffic/train/zfb/1-4.jpg"),
  trainZfbIndex5: require("@/assets/traffic/train/zfb/1-5.jpg"),
  trainZfbIndex6: require("@/assets/traffic/train/zfb/1-6.jpg"),
  trainZfbIndex7: require("@/assets/traffic/train/zfb/1-7.jpg"),
  trainZfbIndex8: require("@/assets/traffic/train/zfb/1-8.jpg"),
  trainZfbIndex9: require("@/assets/traffic/train/zfb/1-9.jpg"),
  trainZfbIndex10: require("@/assets/traffic/train/zfb/1-10.jpg"),
  trainZfbIndex11: require("@/assets/traffic/train/zfb/1-11.jpg"),
  trainZfbIndex12: require("@/assets/traffic/train/zfb/1-12.jpg"),
  trainZfbIndex13: require("@/assets/traffic/train/zfb/1-13.jpg"),
  trainZfbIndex14: require("@/assets/traffic/train/zfb/1-14.jpg"),
  trainZfbIndex15: require("@/assets/traffic/train/zfb/1-15.jpg"),
  trainZfbIndex16: require("@/assets/traffic/train/zfb/1-16.jpg"),
  trainZfbIndex17: require("@/assets/traffic/train/zfb/1-17.jpg"),
  trainZfbIndex18: require("@/assets/traffic/train/zfb/1-18.jpg"),
  trainZfbIndex19: require("@/assets/traffic/train/zfb/1-19.jpg"),
  trainZfbIndex20: require("@/assets/traffic/train/zfb/1-20.jpg"),
  trainZfbIndex21: require("@/assets/traffic/train/zfb/1-21.jpg"),
  trainZfbIndex22: require("@/assets/traffic/train/zfb/1-22.jpg"),

  // 买火车票，铁路12306，主流程图片
  trainTlIndex2: require("@/assets/traffic/train/tl/1-2.jpg"),
  trainTlIndex3: require("@/assets/traffic/train/tl/1-3.jpg"),
  trainTlIndex4: require("@/assets/traffic/train/tl/1-4.jpg"),
  trainTlIndex5: require("@/assets/traffic/train/tl/1-5.jpg"),
  trainTlIndex6: require("@/assets/traffic/train/tl/1-6.jpg"),
  trainTlIndex7: require("@/assets/traffic/train/tl/1-7.jpg"),
  trainTlIndex8: require("@/assets/traffic/train/tl/1-8.jpg"),
  trainTlIndex9: require("@/assets/traffic/train/tl/1-9.jpg"),
  trainTlIndex10: require("@/assets/traffic/train/tl/1-10.jpg"),
  trainTlIndex11: require("@/assets/traffic/train/tl/1-11.jpg"),
  trainTlIndex12: require("@/assets/traffic/train/tl/1-12.jpg"),
  trainTlIndex13: require("@/assets/traffic/train/tl/1-13.jpg"),
  trainTlIndex14: require("@/assets/traffic/train/tl/1-14.jpg"),
  trainTlIndex15: require("@/assets/traffic/train/tl/1-15.jpg"),
  trainTlIndex16: require("@/assets/traffic/train/tl/1-16.jpg"),
  trainTlIndex17: require("@/assets/traffic/train/tl/1-17.jpg"),
  trainTlIndex18: require("@/assets/traffic/train/tl/1-18.jpg"),
  // 网购换货，淘宝，主流程图片
  changeTbIndex2: require("@/assets/shopping/change/tb/2.jpg"),
  changeTbIndex3: require("@/assets/shopping/change/tb/3.jpg"),
  changeTbIndex4: require("@/assets/shopping/change/tb/4.jpg"),
  changeTbIndex5: require("@/assets/shopping/change/tb/5.jpg"),
  changeTbIndex6: require("@/assets/shopping/change/tb/6.jpg"),
  changeTbIndex7: require("@/assets/shopping/change/tb/7.jpg"),
  changeTbIndex8: require("@/assets/shopping/change/tb/8.jpg"),
  changeTbIndex9: require("@/assets/shopping/change/tb/9.jpg"),
  changeTbIndex10: require("@/assets/shopping/change/tb/10.jpg"),
  changeTbIndex11: require("@/assets/shopping/change/tb/11.jpg"),
  changeTbIndex12: require("@/assets/shopping/change/tb/12.jpg"),
  // 网购换货，京东，主流程图片
  changeJdIndex2: require("@/assets/shopping/change/jd/2.jpg"),
  changeJdIndex3: require("@/assets/shopping/change/jd/3.jpg"),
  changeJdIndex4: require("@/assets/shopping/change/jd/4.jpg"),
  changeJdIndex5: require("@/assets/shopping/change/jd/5.jpg"),
  changeJdIndex6: require("@/assets/shopping/change/jd/6.jpg"),
  changeJdIndex7: require("@/assets/shopping/change/jd/7.jpg"),
  changeJdIndex8: require("@/assets/shopping/change/jd/8.jpg"),
  changeJdIndex9: require("@/assets/shopping/change/jd/9.jpg"),
  changeJdIndex10: require("@/assets/shopping/change/jd/10.jpg"),
  changeJdIndex11: require("@/assets/shopping/change/jd/11.jpg"),
  //  网购换货，拼多多，主流程图片
  changePddIndex2: require("@/assets/shopping/change/pdd/2.jpg"),
  changePddIndex3: require("@/assets/shopping/change/pdd/3.jpg"),
  changePddIndex4: require("@/assets/shopping/change/pdd/4.jpg"),
  changePddIndex5: require("@/assets/shopping/change/pdd/5.jpg"),
  changePddIndex6: require("@/assets/shopping/change/pdd/6.jpg"),
  changePddIndex7: require("@/assets/shopping/change/pdd/7.jpg"),
  changePddIndex8: require("@/assets/shopping/change/pdd/8.jpg"),
  changePddIndex9: require("@/assets/shopping/change/pdd/9.jpg"),
  changePddIndex10: require("@/assets/shopping/change/pdd/10.jpg"),
  changePddIndex11: require("@/assets/shopping/change/pdd/11.jpg"),
  changePddIndex12: require("@/assets/shopping/change/pdd/12.jpg"),
  changePddIndex13: require("@/assets/shopping/change/pdd/13.jpg"),
  //  网购换货，拼多多，分支1图片
  changePddBranch1Index1: require("@/assets/shopping/change/pdd/branch1/1.jpg"),
  changePddBranch1Index2: require("@/assets/shopping/change/pdd/branch1/2.jpg"),
  changePddBranch1Index3: require("@/assets/shopping/change/pdd/branch1/3.jpg"),
  changePddBranch1Index4: require("@/assets/shopping/change/pdd/branch1/4.jpg"),
  //  网购换货，拼多多，分支2图片
  changePddBranch2Index1: require("@/assets/shopping/change/pdd/branch2/1.jpg"),
  changePddBranch2Index2: require("@/assets/shopping/change/pdd/branch2/2.jpg"),
  changePddBranch2Index3: require("@/assets/shopping/change/pdd/branch2/3.jpg"),
  changePddBranch2Index4: require("@/assets/shopping/change/pdd/branch2/4.jpg"),
  //  网购换货，抖音，主流程图片
  changeDyIndex2: require("@/assets/shopping/change/dy/2.jpg"),
  changeDyIndex3: require("@/assets/shopping/change/dy/3.jpg"),
  changeDyIndex4: require("@/assets/shopping/change/dy/4.jpg"),
  changeDyIndex5: require("@/assets/shopping/change/dy/5.jpg"),
  changeDyIndex6: require("@/assets/shopping/change/dy/6.jpg"),
  changeDyIndex7: require("@/assets/shopping/change/dy/7.jpg"),
  changeDyIndex8: require("@/assets/shopping/change/dy/8.jpg"),
  changeDyIndex9: require("@/assets/shopping/change/dy/9.jpg"),
  changeDyIndex10: require("@/assets/shopping/change/dy/10.jpg"),
  //  网购换货，抖音，分支1图片
  changeDyBranch1Index2: require("@/assets/shopping/change/dy/branch1/2.jpg"),
  changeDyBranch1Index3: require("@/assets/shopping/change/dy/branch1/3.jpg"),
  changeDyBranch1Index4: require("@/assets/shopping/change/dy/branch1/4.jpg"),
  changeDyBranch1Index5: require("@/assets/shopping/change/dy/branch1/5.jpg"),
  changeDyBranch1Index6: require("@/assets/shopping/change/dy/branch1/6.jpg"),
  //  网购换货，抖音，分支2图片
  changeDyBranch2Index2: require("@/assets/shopping/change/dy/branch2/2.jpg"),
  changeDyBranch2Index3: require("@/assets/shopping/change/dy/branch2/3.jpg"),
  changeDyBranch2Index4: require("@/assets/shopping/change/dy/branch2/4.jpg"),
  changeDyBranch2Index5: require("@/assets/shopping/change/dy/branch2/5.jpg"),
  changeDyBranch2Index6: require("@/assets/shopping/change/dy/branch2/6.jpg"),

  // 网购退货，淘宝，主流程图片
  refundTbIndex6: require("@/assets/shopping/refund/tb/6.jpg"),
  refundTbIndex7: require("@/assets/shopping/refund/tb/7.jpg"),
  refundTbIndex8: require("@/assets/shopping/refund/tb/8.jpg"),
  refundTbIndex9: require("@/assets/shopping/refund/tb/9.jpg"),
  refundTbIndex10: require("@/assets/shopping/refund/tb/10.jpg"),
  refundTbIndex11: require("@/assets/shopping/refund/tb/11.jpg"),
    //  网购退货，拼多多，分支1图片
    refundTbBranch1Index1: require("@/assets/shopping/refund/tb/branch1/1.jpg"),
    refundTbBranch1Index2: require("@/assets/shopping/refund/tb/branch1/2.jpg"),
    refundTbBranch1Index3: require("@/assets/shopping/refund/tb/branch1/3.jpg"),
    refundTbBranch1Index4: require("@/assets/shopping/refund/tb/branch1/4.jpg"),
    refundTbBranch1Index5: require("@/assets/shopping/refund/tb/branch1/5.jpg"),
  // 网购退货，京东，主流程图片
  refundJdIndex5: require("@/assets/shopping/refund/jd/5.jpg"),
  refundJdIndex6: require("@/assets/shopping/refund/jd/6.jpg"),
  refundJdIndex7: require("@/assets/shopping/refund/jd/7.jpg"),
  refundJdIndex8: require("@/assets/shopping/refund/jd/8.jpg"),
  //  网购退货，拼多多，主流程图片
  refundPddIndex6: require("@/assets/shopping/refund/pdd/6.jpg"),
  refundPddIndex7: require("@/assets/shopping/refund/pdd/7.jpg"),
  refundPddIndex8: require("@/assets/shopping/refund/pdd/8.jpg"),
  refundPddIndex9: require("@/assets/shopping/refund/pdd/9.jpg"),
  refundPddIndex10: require("@/assets/shopping/refund/pdd/10.jpg"),
  refundPddIndex11: require("@/assets/shopping/refund/pdd/11.jpg"),
  refundPddIndex12: require("@/assets/shopping/refund/pdd/12.jpg"),
  refundPddIndex13: require("@/assets/shopping/refund/pdd/13.jpg"),
  //  网购退货，拼多多，分支1图片
  refundPddBranch1Index1: require("@/assets/shopping/refund/pdd/branch1/1.jpg"),
  refundPddBranch1Index3: require("@/assets/shopping/refund/pdd/branch1/3.jpg"),
  refundPddBranch1Index4: require("@/assets/shopping/refund/pdd/branch1/4.jpg"),
  //  网购退货，拼多多，分支2图片
  refundPddBranch2Index1: require("@/assets/shopping/refund/pdd/branch2/1.jpg"),
  refundPddBranch2Index3: require("@/assets/shopping/refund/pdd/branch2/3.jpg"),
  refundPddBranch2Index4: require("@/assets/shopping/refund/pdd/branch2/4.jpg"),
  //  网购退货，抖音，主流程图片
  refundDyIndex5: require("@/assets/shopping/refund/dy/5.jpg"),
  refundDyIndex6: require("@/assets/shopping/refund/dy/6.jpg"),
  refundDyIndex7: require("@/assets/shopping/refund/dy/7.jpg"),
  refundDyIndex8: require("@/assets/shopping/refund/dy/8.jpg"),
  refundDyIndex9: require("@/assets/shopping/refund/dy/9.jpg"),
  //  网购退货，抖音，分支1图片
  refundDyBranch1Index2: require("@/assets/shopping/refund/dy/branch1/2.jpg"),
  refundDyBranch1Index3: require("@/assets/shopping/refund/dy/branch1/3.jpg"),
  refundDyBranch1Index4: require("@/assets/shopping/refund/dy/branch1/4.jpg"),
  refundDyBranch1Index5: require("@/assets/shopping/refund/dy/branch1/5.jpg"),
  refundDyBranch1Index6: require("@/assets/shopping/refund/dy/branch1/6.jpg"),
  //  网购退货，抖音，分支2图片
  refundDyBranch2Index2: require("@/assets/shopping/refund/dy/branch2/2.jpg"),
  refundDyBranch2Index3: require("@/assets/shopping/refund/dy/branch2/3.jpg"),
  refundDyBranch2Index4: require("@/assets/shopping/refund/dy/branch2/4.jpg"),
  refundDyBranch2Index5: require("@/assets/shopping/refund/dy/branch2/5.jpg"),
  refundDyBranch2Index6: require("@/assets/shopping/refund/dy/branch2/6.jpg"),
};
